import { notifyLobbyEmbeddedClose } from '../embedded-availability';
import { isEmbeddedInLobby, isEmbeddedQueryRequested } from '../embedded-mode';
import {
  resolveWebWrapper,
  type WebWrapper,
  type WebWrapperDetachPayload,
} from './web-wrapper-bridge';

type WrapperAction = (wrapper: WebWrapper) => void | Promise<void>;

const withLobbyWrapper = async (
  action: WrapperAction,
  requireEmbedded = true,
): Promise<boolean> => {
  if (requireEmbedded && !isEmbeddedInLobby()) {
    return false;
  }

  const wrapper = resolveWebWrapper();
  if (!wrapper) {
    return false;
  }

  await action(wrapper);
  return true;
};

export const notifyShellCloseRequest = async (): Promise<boolean> => {
  const handled = await withLobbyWrapper((wrapper) => wrapper.requestClose());
  if (handled) {
    return true;
  }

  const isEmbeddedShell =
    isEmbeddedQueryRequested() ||
    (typeof window !== 'undefined' && window.parent !== window);

  if (!isEmbeddedShell) {
    return false;
  }

  notifyLobbyEmbeddedClose();
  return true;
};

export const notifyShellDetachRequested = (
  payload: WebWrapperDetachPayload,
): Promise<boolean> =>
  withLobbyWrapper((wrapper) => wrapper.requestDetach(payload));

export const notifyShellDetachReady = (transferId: string): Promise<boolean> =>
  withLobbyWrapper(
    (wrapper) => wrapper.notifyDetachReady({ transferId }),
    false,
  );

export const notifyShellReloadRequired = (): Promise<boolean> =>
  withLobbyWrapper((wrapper) => wrapper.requestReload());

export const notifyShellLogoutRequired = (): Promise<boolean> =>
  withLobbyWrapper((wrapper) => wrapper.requestLogout());
